import merge from 'lodash-es/merge';
import useDefaultChartOptions from '@/components/charts/useDefaultChartOptions';
import usePieChartOptions from '@/components/charts/usePieChartOptions';
import { roundIfNecessary } from '@/util/helpers/numbers';
import { AgeRange, AllFilterSelectors, CourseStatistics, UnknownFilterSelectors } from '@/types';

export const getAllEventsAgeRangeConfig = (id: string, group: number, ageRanges: AgeRange[] | null, courseStatistics: CourseStatistics[]) => {
    return {
        id,
        group,
        printTitle: 'Aldersfordeling (påbegyndte og afsluttede forløb)',
        options: merge(useDefaultChartOptions(), usePieChartOptions(), {
            title: { text: 'Aldersfordeling' },
            series: {
                tooltip: {
                    pointFormatter() {
                        return `<span style="color:${(this as any).color}">●</span> Antal: <b>${(this as any).y}</b><br/><span style="color:${(this as any).color}">●</span> Fordeling: <b>${roundIfNecessary(
                            (this as any).percentage,
                            1
                        )}%</b><br/>`;
                    },
                },
                data:
                    ageRanges
                        ?.filter((currentAgeRange) => currentAgeRange.id !== AllFilterSelectors.AllAgeRanges && currentAgeRange.id !== UnknownFilterSelectors.UnknownAgeRange)
                        ?.map((currentAgeRange) => {
                            return {
                                name: currentAgeRange.title,
                                y: courseStatistics.filter((currentCourseStatistic) => currentCourseStatistic.ageRange === currentAgeRange.id).length,
                            };
                        })
                        .concat([{ name: 'Ikke oplyst', y: courseStatistics.filter((currentCourseStatistic) => !currentCourseStatistic.ageRange).length }])
                        .map((currentDataPoint) => {
                            return {
                                ...currentDataPoint,
                                dataLabels: {
                                    distance: currentDataPoint.y > 0 ? '-50%' : '30',
                                },
                            };
                        }) || [],
            },
        }),
    };
};
